import { createServerFn } from '@tanstack/react-start'

import { convertMarkdownStringToPDF } from '@/lib/markdown-to-pdf'

export const downloadMarkdownAsPDF = createServerFn({ method: 'POST' })
  .inputValidator((d: string) => d)
  .handler(async ({ data: markdown }) => {
    try {
      const pdf = await convertMarkdownStringToPDF(markdown)

      if (!pdf) throw new Error('PDF generation failed')

      return new Response(pdf, {
        status: 200,
        headers: {
          'Content-Type': 'application/pdf',
          'Content-Disposition': 'attachment; filename="resume.pdf"',
          'Cache-Control': 'no-cache',
        },
      })
    } catch (error) {
      throw new Error('Failed to generate PDF')
    }
  })
